import { get } from 'lodash';
import { createAction as makeActionCreator } from 'redux-actions';

import api from '../api/';
import i18n from '../i18n';
import { handleError } from './errors';

export const unitInfoRequested = makeActionCreator('UNIT_INFO_REQUESTED');
export const unitInfoReceived = makeActionCreator('UNIT_INFO_RECEIVED');
export const unitsReceived = makeActionCreator('UNITS_RECEIVED');
export const resourcesReceived = makeActionCreator('RESOURCES_RECEIVED');
export const groupsReceived = makeActionCreator('GROUPS_RECEIVED');
export const fetchingStaticData = makeActionCreator('LOADING_DATA_FETCHED');
export const staticDataFetched = makeActionCreator('STATIC_DATA_FETCHED');

export const localizeUnitName = (units) => {
  const activeLanguage = i18n.language;
  const t = i18n.getFixedT(activeLanguage, 'common');
  return units.map(
    (u) => {
      const { unit, name, ...rest } = u;
      return {
        unit,
        ...rest,
        name: t(`units.${unit}`, name)
      };
    }
  );
};

export const fetchUponLogin = (dispatch, getState) => () => {
  dispatch(fetchingStaticData);

  const { booking } = getState();

  const unitsPromise = api.requestUnits(booking.legalEntity)
    .then(localizeUnitName)
    .then(data => dispatch(unitsReceived(data)))
    .catch(dispatch(handleError));
  const resourcesPromise = api.requestResources()
    .then(data => dispatch(resourcesReceived(data)))
    .catch(dispatch(handleError));
  const groupsPromise = api.requestGroups()
    .then(data => dispatch(groupsReceived(data)))
    .catch(dispatch(handleError));
  Promise.all([unitsPromise, groupsPromise, resourcesPromise])
    .then(() => dispatch(staticDataFetched));
};

export const fetchThroughHashedApi = dispatch => (legalEntity) => {
  dispatch(fetchingStaticData);
  const unitsPromise = api.requestUnitsThroughHashedApi(legalEntity)
    .then(localizeUnitName)
    .then(data => dispatch(unitsReceived(data)))
    .catch(dispatch(handleError));
  const resourcesPromise = api.requestResourcesThroughHashedApi()
    .then(data => dispatch(resourcesReceived(data)))
    .catch(dispatch(handleError));
  const groupsPromise = api.requestGroupsThroughHashedApi()
    .then(data => dispatch(groupsReceived(data)))
    .catch(dispatch(handleError));
  Promise.all([unitsPromise, groupsPromise, resourcesPromise])
    .then(() => dispatch(staticDataFetched));
};

const fetchUnitInfoPromise = (unit, userIdentified) => {
  if (userIdentified) {
    return api.requestUnitInfo(unit);
  }
  return api.requestUnitInfoThroughHashedApi(unit);
};

export const fetchUnitInfo = dispatch => (unit, userIdentified) => {
  console.log('Fetching unit info', unit);
  // check for canAnonymousFetchTimes and either call api.requestUnitInfo or api.requestUnitInfoThroughHashedApi
  fetchUnitInfoPromise(unit, userIdentified)
  .then(data => dispatch(unitInfoReceived({ ...data, unit })))
  .catch(dispatch(handleError));
};



// WEBPACK FOOTER //
// ./src/actions/ehrResources.js